import { Component, Injector, Input } from '@angular/core';

import { GenericListComponent } from '@core/globals/generic-list/generic-list.component';
import { SignalsService } from '@core/services/signals.service';
import { WaycomHttpErrorResponse } from '@core/services/waycom-http-error-response';

@Component({
  selector: 'app-meraki-switch-profiles-list',
  templateUrl: './meraki-switch-profiles-list.component.html',
  styles: []
})
export class MerakiSwitchProfilesListComponent extends GenericListComponent {
  @Input() public orgaMerakiCode: string;
  public loading: boolean;

  constructor(
    public injector: Injector,
    private signalsService: SignalsService
  ) {
    super(injector);
    this.localDisabledButtons = { syncSwitchProfiles: true };
  }

  public syncSwitchProfiles() {
    if (!this.orgaMerakiCode) { return; }
    this.loading = true;
    this.apiProvitool.meraki_organizations.refresh_switch_profiles(this.orgaMerakiCode).then(() => {
      this.signalsService.broadcast('meraki-switch-profiles-list-refresh');
    }).catch(err => {
      if (err instanceof WaycomHttpErrorResponse) {
        if (err.getFirstErrorMessage() === 'EMPTY_TEMPLATE_LIST') {
          this.toastr.error(`La liste des templates est vide.`);
          return;
        } else if (err.getFirstErrorMessage() === 'COULD_NOT_REFRESH') {
          this.toastr.error(`Une erreur est survenue lors de la synchronisation.`);
          return;
        }
      }
      Promise.reject(err);
    }).finally( () => { this.loading = false; });
  }
}


